import React from 'react';
import AtomicButton from '../../atomic/button/Button';
import { isIpad, isMobile } from '../../utils/ScreenSizeHelper';
import { useNavigate } from 'react-router-dom';

const BRAND = '#3F3F6E';
const BRAND_SOFT = '#EEEEF6';
const TEXT_MUTED = '#6B6B8A';

const steps = [
  { title: 'Log in to your dashboard', desc: 'Use the email and password you just created.' },
  { title: 'Add your menu & hours', desc: 'It only takes a few minutes to get set up.' },
  {
    title: 'Get ready for launch',
    desc: "Your dedicated manager will work closely with you, and we'll notify you as soon as we go live.",
  },
];

const CheckIcon = () => (
  <svg width='28' height='28' viewBox='0 0 24 24' fill='none' aria-hidden='true'>
    <path
      d='M5 12.5l4.5 4.5L19 7.5'
      stroke='white'
      strokeWidth='2.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const ThankYouSignup = () => {
  const navigate = useNavigate();

  const goToLogin = () => {
    navigate('/login');
    window.location.reload();
  };

  const compact = isIpad || isMobile;

  return (
    <>
      <style>{`
        @keyframes tySlideIn {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes tyPop {
          0%   { transform: scale(0.6); opacity: 0; }
          70%  { transform: scale(1.08); opacity: 1; }
          100% { transform: scale(1); }
        }
      `}</style>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          maxWidth: '400px',
          boxSizing: 'border-box',
          backgroundColor: 'white',
          borderRadius: '16px',
          margin: isIpad ? '20% auto' : '10% 10% 10% 20%',
          padding: compact ? '28px 24px' : '44px 40px',
          boxShadow: '0 12px 40px rgba(63, 63, 110, 0.15), 0 2px 6px rgba(0, 0, 0, 0.05)',
          borderTop: `4px solid ${BRAND}`,
          animation: 'tySlideIn 0.5s ease-out',
        }}
      >
        {/* Success badge */}
        <div
          style={{
            width: '60px',
            height: '60px',
            borderRadius: '50%',
            backgroundColor: BRAND,
            boxShadow: `0 0 0 8px ${BRAND_SOFT}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '28px',
            animation: 'tyPop 0.5s ease-out 0.15s both',
          }}
        >
          <CheckIcon />
        </div>

        {/* Heading */}
        <div
          style={{
            color: BRAND,
            fontSize: compact ? '26px' : '30px',
            fontWeight: 700,
            lineHeight: 1.2,
            marginBottom: '12px',
          }}
        >
          Welcome aboard! 🎉
        </div>

        {/* Message */}
        <div
          style={{
            color: TEXT_MUTED,
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: 1.6,
            marginBottom: '28px',
          }}
        >
          Thank you for partnering with us. We're excited to help your restaurant reach more hungry
          customers and grow — on your terms.
        </div>

        {/* Next steps */}
        <div
          style={{
            backgroundColor: '#F8F8FC',
            borderRadius: '12px',
            padding: '18px 20px',
            marginBottom: '28px',
          }}
        >
          <div
            style={{
              fontSize: '12px',
              fontWeight: 700,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: BRAND,
              marginBottom: '14px',
            }}
          >
            What's next
          </div>

          {steps.map((step, i) => (
            <div
              key={step.title}
              style={{
                display: 'flex',
                gap: '12px',
                marginBottom: i === steps.length - 1 ? 0 : '14px',
              }}
            >
              <div
                style={{
                  flexShrink: 0,
                  width: '24px',
                  height: '24px',
                  borderRadius: '50%',
                  backgroundColor: BRAND_SOFT,
                  color: BRAND,
                  fontSize: '12px',
                  fontWeight: 700,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {i + 1}
              </div>
              <div>
                <div style={{ color: BRAND, fontSize: '14px', fontWeight: 600 }}>{step.title}</div>
                <div style={{ color: TEXT_MUTED, fontSize: '13px', lineHeight: 1.5 }}>
                  {step.desc}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <AtomicButton
          label='Log in to get started'
          handleSubmit={goToLogin}
          style={{ backgroundColor: BRAND, borderRadius: '10px' }}
          loading={false}
          disabled={false}
        />

        <div
          style={{
            textAlign: 'center',
            color: TEXT_MUTED,
            fontSize: '13px',
            marginTop: '16px',
          }}
        >
          Need a hand? Our team is always here to help.
        </div>
      </div>
    </>
  );
};

export default ThankYouSignup;
